module.exports = __webpack_public_path__ + "assets/icon-card-big.9efa3d4b.svg";